module.exports = __webpack_public_path__ + "img/n2.f2f33345.png";